export default __webpack_public_path__ + "static/media/msg.4fef1948.svg";